import { useEffect, useMemo, useRef, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { genarateStudentRecurringInvoices, getStudentInvoicesWithPagination, reverseStudentInvoice, sendStudentBulkEmailInvoices } from '@app/services/student';
import DataTable, { TableStyles } from 'react-data-table-component';
import { Button } from '@app/components';
import { getAllActiveFranchise } from '@app/services/franchise';
import Select from "react-select";
import CurrencyFormat from 'react-currency-format';
import moment from 'moment';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import PayInvoiceAmountModal from './PayInvoiceAmountModal';
import fileDownload from 'js-file-download';
import ExcelJS from "exceljs/dist/es5/exceljs.browser";
import { confirmAlert } from 'react-confirm-alert';
import "./studentInvoice.css"

const ListStudentInvoices = () => {

    let obj: any = {}
    const selectRef = useRef(null);
    const selectRefGen = useRef(null);
    const [students, setStudents] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [isInvoiceLoading, setInvoiceLoading] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams()
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(searchParams.get('perPage') ?? 10);
    const [currentPage, setCurrentPage] = useState(searchParams.get('page') ?? 1);
    const [franchises, setFranchises] = useState([]);
    const [franchisesGen, setFranchisesGen] = useState([]);
    const invoiceStatuses = [{label:'Cancelled', value:'cancelled'}, {label:'Mirrored', value:'mirrored'}, {label:'Paid', value:'paid'}, {label:'Partially Paid', value:'partially-paid'}, {label:'Reversed', value:'reversed'}, {label:'Unpaid', value:'unpaid'}]
    const canAccess = useSelector((state: any) => state.auth.permissions.student);
    const [months, setMonths] = useState([]);
    const allMonths = [{id: 1, name:'January'}, {id: 2, name:'February'}, {id: 3, name:'March'}, 
                    {id: 4, name:'April'}, {id: 5, name:'May'}, {id: 6, name:'June'},
                    {id: 7, name:'July'},{id: 8, name:'August'},{id: 9, name:'September'},
                    {id: 10, name:'October'}, {id: 11, name:'November'}, {id: 12, name:'December'}];
    const years = Array.from( { length: 2 }, (_, index) => new Date().getFullYear() - index );
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [payload, setPayload] = useState(obj);
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [hasMail, setHasMail] = useState(searchParams.get('mailable') == 'false' ? 'not_applicable' : (searchParams.get('hasMessageSent') ? (searchParams.get('hasMessageSent') == 'true' ? 'yes': 'no') : ''));
    const navigate = useNavigate()
    const [t] = useTranslation()

    useEffect(() => {
        if(canAccess.invoices == false){
            toast.error(t('auth.noAccess'))
            navigate('/')
        }
    }, [])
    
    const customStyle: TableStyles = {
        head: {
            style: {
                color: "#5E5873",
                fontSize: "13px",
                fontWeight: 900,
            },
        },
        headCells: {
            style: {
                borderColor: "#E9ECEF",
                textTransform: "uppercase",
                letterSpacing: "1px",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#F7F7F8",
                minHeight: "44px",
                fontWeight: 500,
            },
        },
    };

    const customStylesSelect = {
        dropdownIndicator: () => ({
            display: 'none',
        }),
    }

    useEffect(() => {
        getAllStudentInvoices();
    },[searchParams]);

    useEffect(() => {
        getAllActiveFranchiseData()
        setMonths(allMonths.filter((month) => {
            return month.id <= new Date().getMonth() + 1
        }))
    },[]);

    const getAllStudentInvoices = async () => {
        try {
            setLoading(true);
            setToggleCleared(!toggleCleared)
            const studentsResp = await getStudentInvoicesWithPagination(searchParams);
            if (studentsResp.success === true) {
                setLoading(false);
                setStudents(studentsResp.collections.data);
                setTotalRows(studentsResp?.collections?.pagination?.total);
            } else {
                setLoading(false);
                toast.error(studentsResp?.errors[0]?.msg);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Something went wrong');
        }
    };

    const getAllActiveFranchiseData = async () => {
        try {
            const resp = await getAllActiveFranchise();
            if (resp?.success === true) {
                setFranchises(resp?.collections)
                let arr = [...resp?.collections]
                arr.unshift({id: 'all', name: 'All', enabled_recurring_invoice: true})
                setFranchisesGen(arr.filter((franchise) => franchise.enabled_recurring_invoice == true))
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Something went wrong');
        }
    };

    const getInvoiceStatusClass = (status) => {
        switch (status) {
            case 'paid':
                return 'bg-success';
            case 'unpaid': 
                return 'bg-warning';
            case 'mirrored':
                return 'bg-info';
            case 'partially-paid':
                return 'bg-secondary';
            case 'cancelled':
            case 'reversed':
                return 'bg-danger';
            default:
                return 'bg-warning';
        }
    };

    const columns = [
        {
            name: 'Invoice Id',
            selector: (row: { invoice_number: string;}) => row.invoice_number,
            sortable: true,
            sortField: 'invoice_number',
            wrap: true,
        },
        {
            name: 'Roll No.',
            selector: (row: { roll_number: string;}) => row.roll_number ?? '---',
            sortable: true,
            sortField: 'roll_number',
            wrap: true,
        },
        {
            name: 'Student Name',
            selector: (row: { student_name: string;}) => row.student_name,
            sortable: true,
            sortField: 'student_name',
            wrap: true,
        },
        {
            name: 'Franchise',
            selector: (row: { franchise_name: string; }) => row.franchise_name ? row.franchise_name : '---',
            sortable: true,
            sortField: 'franchise_name',
            wrap: true,
        },
        // {
        //     name: 'Year Group',
        //     selector: (row: {year_group: string;}) => row.year_group ?? '---',
        //     sortable: true,
        //     sortField: 'year_group',
        //     wrap: true,
        // },
        {
            name: 'Invoice Amount',
            selector: (row: { invoice_amount: string, currency: string }) => row.invoice_amount,
            format: (row: { invoice_amount: string, currency: string }) => <CurrencyFormat value={ (parseFloat(row.invoice_amount)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ row.currency + ' '} />,
            sortable: true,
            sortField: 'invoice_amount',
        },
        {
            name: 'Outstanding Amount',
            selector: (row: { invoice_amount_outstanding: string, currency: string }) => row.invoice_amount_outstanding,
            format: (row: { invoice_amount_outstanding: string, currency: string }) => <CurrencyFormat value={ (parseFloat(row.invoice_amount_outstanding)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ row.currency + ' '} />,
            sortable: true,
            sortField: 'invoice_amount_outstanding',
        },
        {
            name: 'Amount Paid',
            selector: (row: { invoice_amount_paid: string, currency: string }) => row.invoice_amount_paid,
            format: (row: { invoice_amount_paid: string, currency: string }) => <CurrencyFormat value={ (parseFloat(row.invoice_amount_paid)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ row.currency + ' '} />,
            sortable: true,
            sortField: 'invoice_amount_paid',
        },
        {
            name: 'Invoice Duration',
            selector: (row: {invoice_from_date: string, invoice_to_date: string}) => moment(row.invoice_from_date).format('MMM - YYYY'),//moment(row.invoice_from_date).format('Do MMM YYYY') + ' - ' + moment(row.invoice_to_date).format('Do MMM YYYY'),
            sortable: false,
            wrap: true,
        },
        {
            name: 'Is Mail Sent?',
            // selector: (row: { invoice_status: string; }) => row.invoice_status,
            cell: (row: { id: number, mailable: boolean, has_message_sent: boolean}) => (
                <>
                    {  !row.mailable ? <span className="badge bg-secondary">N/A</span> : 
                        (row.has_message_sent ? <span className="capitalize badge bg-success">Yes</span> : 
                            <span className="capitalize badge bg-warning">No</span>) }
                </>
            ),
            sortable: false,
            // sortField: 'invoice_status',
        },
        {
            name: 'Status',
            selector: (row: { invoice_status: string; }) => row.invoice_status,
            cell: (row) => (
                <a
                    href="javascript:void(0)"
                    onClick={() => {
                        if (
                            canAccess?.['update-invoice-payment'] &&
                            row.invoice_status !== 'paid' &&
                            row.invoice_status !== 'cancelled' &&
                            row.invoice_status !== 'reversed' && 
                            row.invoice_status !== 'mirrored'
                        ) {
                            handleUpdateInvoicePayment({
                                student_invoice_id: row.id,
                                invoice_number: row.invoice_number,
                                invoice_amount: row.invoice_amount,
                                amount_outstanding: row.invoice_amount_outstanding,
                                amount_paid: row.invoice_amount_paid,
                                franchise_name: row.franchise_name,
                                student_name: row.student_name,
                                currency: row.currency
                            });
                        }
                    }}
                    data-toggle="tooltip"
                    title="Update order status"
                >
                    <span className={`capitalize badge ${getInvoiceStatusClass(row.invoice_status)}`}>
                        {row.invoice_status}
                    </span>
                </a>
            ),
            sortable: true,
            sortField: 'invoice_status',
        },
        {
            name: 'Created On',
            selector: (row: { created_at: string; }) => row.created_at ? moment(row.created_at).format('DD-MM-YYYY') : '---',
            sortable: true,
            sortField: 'created_at',
        },
        {  
            name: 'Action',
            cell: (row: { id: number, student_name: string, status: string, mailable: boolean, invoice_status: string, invoice_number: string, invoice_amount: string, invoice_amount_outstanding: string, invoice_amount_paid: string, currency: string, invoice_from_date: string, invoice_to_date: string, document_type: string }) => (
              <>
                { canAccess?.['view-invoice-details'] && 
                    <Link
                        to={`/student-invoices/details/${row.id}`}
                        role="button"
                        state={{ id: row.id }}
                        data-toggle="tooltip" title="View Details"
                    >
                    <i className="fas fa-eye mr-2"/>
                    </Link>
                }
                { canAccess?.['view-student-invoice'] &&
                    <Link
                        to={`/student-invoices/view/${row.id}`}
                        role="button"
                        state={{ id: row.id }}
                        data-toggle="tooltip" title={row?.document_type === 'credit_note' ? "View Credit Note" : "View Invoice"}
                        target={'_blank'}
                    >
                    <i className="fas fa-receipt mr-2"/>
                    </Link>
                }
                { canAccess?.['send-invoice-email'] && row?.mailable && row.invoice_status != 'cancelled' &&
                    <a href="#" onClick={ (e) => handleEmailInvoice(e, {id: row.id, student_name: row.student_name})} data-toggle="tooltip" title="Send Invoice Email"> 
                        <i className="fas fa-envelope-open-text mr-2"/>
                    </a> 
                }
                { canAccess?.['reverse-invoice'] && (row.invoice_status == 'unpaid' || row.invoice_status == 'partially-paid') &&
                    <a href="#" onClick={ (e) => handleReverseInvoice(e, {id: row.id, student_name: row.student_name, invoice_number: row.invoice_number, invoice_amount: row.invoice_amount, invoice_amount_outstanding: row.invoice_amount_outstanding, invoice_amount_paid: row.invoice_amount_paid, currency: row.currency, invoice_from_date: row.invoice_from_date, invoice_to_date: row.invoice_to_date})} data-toggle="tooltip" title="Reverse Invoice"> 
                        <i className="fas fa-exchange-alt"/>
                    </a> 
                }
              </>
            ),
        },
    ];

    const handleUpdateInvoicePayment = async(payload) => {
        handleShow()
        setPayload(payload)
    }

    const handlePageChange = page => {
        searchParams.set('page', page)
        setSearchParams(searchParams)
        
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        setSelectedRows([])
        searchParams.set('perPage', newPerPage)
        setSearchParams(searchParams)
        
        setPerPage(newPerPage);
    };

    const handleSort = async (column, sortDirection) => {
        searchParams.set('sortField', column.sortField)
        searchParams.set('sortDirection', sortDirection)
        setSearchParams(searchParams)
    };

    const handleResetFilter = async () => {
        setToggleCleared(!toggleCleared)
        setSelectedRows([])
        selectRef.current.setValue('');
        searchParams.delete('invoiceNumber')
        searchParams.delete('studentName')
        searchParams.delete('franchiseId')
        searchParams.delete('invoiceAmount')
        searchParams.delete('invoiceAmountOutstanding')
        searchParams.delete('invoiceAmountPaid')
        searchParams.delete('invoiceStatus')
        searchParams.delete('mailable')
        searchParams.delete('hasMessageSent')
        setHasMail('')
        setSearchParams(searchParams)
    };

    const onChangeFranchise = (option) => {
        searchParams.set('franchiseId', option == null ? '' : option.id )
        setSearchParams(searchParams)
    };

    const generateRecurringInvoices = async (payload) => {
        try {
            setInvoiceLoading(true)
            const resp = await genarateStudentRecurringInvoices(payload);
            if (resp?.success === true) {
                setInvoiceLoading(false)
                resetForm()
                selectRefGen.current.setValue('');
                toast.success(resp?.message)
                getAllStudentInvoices();
            } else {
                setInvoiceLoading(false)
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            setInvoiceLoading(false)
            toast.error(error?.message || 'Something went wrong');
        }
    };

    const handleReverseInvoice = (e, payload) => {
        confirmAlert({
            customUI: ({ onClose }) => (
                <div className="confirm-modal">
                    <div className="confirm-modal__header">
                        <h2>Reverse Invoice</h2>
                        <p>Are you sure you want to Reverse the Invoice?</p>
                    </div>

                    <div className="confirm-grid">
                        <div>Student Name:</div>
                        <div><b>{payload?.student_name}</b></div>

                        <div>Invoice Number:</div>
                        <div><b>{payload?.invoice_number}</b></div>

                        <div>Invoice Amount:</div>
                        <div><b><CurrencyFormat value={ (parseFloat(payload?.invoice_amount)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ payload?.currency + ' '} /></b></div>

                        <div>Outstanding Amount:</div>
                        <div><b><CurrencyFormat value={ (parseFloat(payload?.invoice_amount_outstanding)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ payload?.currency + ' '} /></b></div>

                        <div>Invoice Duration:</div>
                        <div>
                            <b>
                                {moment(payload?.invoice_from_date).format("Do MMM YYYY")} -{" "}
                                {moment(payload?.invoice_to_date).format("Do MMM YYYY")}
                            </b>
                        </div>
                    </div>
                    <div className="confirm-modal__actions">
                        <button
                            className="btn-secondary"
                            onClick={() => {
                                setLoading(false);
                                onClose();
                            }}
                        >
                            No
                        </button>
                        <button
                            className="btn-primary"
                            onClick={() => {
                                reverseInvoice(payload.id);
                                onClose();
                            }}
                        >
                            Yes
                        </button>
                    </div>
                </div>
            ),
        });
        e.preventDefault();
    }

    const reverseInvoice = async (id) => {
        try {
            setInvoiceLoading(true)
            const resp = await reverseStudentInvoice(id);
            if (resp?.success === true) {
                setInvoiceLoading(false)
                toast.success(resp?.message)
                getAllStudentInvoices();
            } else {
                setInvoiceLoading(false)
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            setInvoiceLoading(false)
            toast.error(error?.message || 'Something went wrong');
        }
    };

    const { handleChange, values, handleSubmit, touched, errors, setFieldValue, resetForm } = useFormik({
        initialValues: {
            franchise_id: '',
            year: '',
            month: '',
        },
        validationSchema: Yup.object({
            franchise_id: Yup.string().required('Please select franchise'),
            year: Yup.string().required('Please select year'),
            month: Yup.string().required('Please select month'),
        }),
        onSubmit: (values) => {
            confirmAlert({
                title: 'Generate Invoices',
                message: 'Are you sure you want to generate the invoices?',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: () => generateRecurringInvoices(values)
                    },
                    {
                        label: 'No',
                        onClick: () => {}
                    }
                ]
            });
        },
        enableReinitialize: true,
    });

    const onYearChange = (e) => {
        setFieldValue('year', e.target.value)
        if(e.target.value != ''){
            if(e.target.value == new Date().getFullYear()){
                setMonths(allMonths.filter((month) => {
                    return month.id <= new Date().getMonth() + 1
                }))
            }else if(e.target.value < new Date().getFullYear()){
                setMonths(allMonths)
            }
        }else{
            setMonths([])
        }
    }

    const exportCSV = async() => {
        try {
            setLoading(true);
            searchParams.set('perPage', totalRows.toString())
            let records = await getStudentInvoicesWithPagination(searchParams)
            searchParams.set('perPage', '10')
            if (records.success === true) {
                setLoading(false);
            } else {
                setLoading(false);
                toast.error(records?.errors[0]?.msg);
                return;
            }

            if((records?.collections?.data).length === 0){
                toast.error('Records not found.')
                return;
            }

            const workbook = new ExcelJS.Workbook();
            workbook.addWorksheet("Student-Invoices");
            const worksheet = workbook.getWorksheet('Student-Invoices');
            worksheet.columns = [
                { header: "Invoice Id", key: "invoice_number" },
                { header: "Student Name", key: "student_name" },
                { header: "Grade", key: "year_group" },
                { header: "Franchise", key: "franchise_name" },
                { header: "Net Amount", key: "invoice_net_amount" },
                { header: "VAT Amount", key: "invoice_vat" },
                { header: "Credit Amount", key: "credit_amount" },
                { header: "Invoice Amount", key: "invoice_amount" },
                { header: "Invoice Amount Outstanding", key: "invoice_amount_outstanding" },
                { header: "Invoice Amount Paid", key: "invoice_amount_paid" },
                { header: "Invoice From Date", key: "invoice_from_date" },
                { header: "Invoice To Date", key: "invoice_to_date" },
                { header: "Is Mail Sent?", key: "has_message_sent" },
                { header: "Status", key: "invoice_status" },
                { header: "Created On", key: "created_at" },
            ];
            
            (records?.collections?.data).map((row) => {
                row.year_group = row.year_group !== null ? row.year_group : '---';
                row.invoice_amount = row.invoice_amount !== null ? (parseFloat(row.invoice_amount)).toFixed(2) : '---';
                row.invoice_amount_outstanding = row.invoice_amount_outstanding !== null ? (parseFloat(row.invoice_amount_outstanding)).toFixed(2) : '---';
                row.invoice_amount_paid = row.invoice_amount_paid !== null ? (parseFloat(row.invoice_amount_paid)).toFixed(2) : '---';
                row.credit_amount = row.credit_amount !== null ? '- ' + (parseFloat(row.credit_amount)).toFixed(2) : '---';
                row.invoice_status = row.invoice_status.charAt(0).toUpperCase() + row.invoice_status.slice(1);
                row.invoice_from_date = row.invoice_from_date !== null ? moment(row.invoice_from_date).format('DD/MM/YYYY') : '---';
                row.invoice_to_date = row.invoice_to_date !== null ? moment(row.invoice_to_date).format('DD/MM/YYYY') : '---';
                row.has_message_sent = row.mailable ? (row.has_message_sent ? 'Yes' : 'No') : 'N/A';
            })

            worksheet.addRows(records?.collections?.data);
            let filename = 'Student-Invoices-' + moment().format('DD-MMM-YYYY') + '.csv';

            workbook.csv.writeBuffer().then(function(buffer) {
                fileDownload(buffer, filename);
            });
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal Server Error')
        }
    }

    const sendBulkInvoiceEmail = async (payload) => {
        try {
            setLoading(true)
            setToggleCleared(!toggleCleared)
            const resp = await sendStudentBulkEmailInvoices(payload)
            if(resp.success === true){
                setLoading(false)
                getAllStudentInvoices()
                toast.success(resp?.message)
            }else{
                toast.error(resp?.errors[0]?.msg)
                setLoading(false)
            }
        } catch (error: any) {
            setLoading(false)
            toast.error(error?.message || 'Internal Server Error')
        }
    };

    const rowDisabledCriteria = row => !row.mailable || row.has_message_sent || row.invoice_status == 'cancelled';

    const handleSelectedRows = ({ selectedRows }) => {
        setSelectedRows(selectedRows)
    };

    const contextActions = useMemo(() => {
        const handleSendEmail = () => {
            confirmAlert({
                title: 'Email Invoices',
                message: `Do you want to send invoice to ${selectedRows.map(r => r.student_name)}?`,
                buttons: [
                    {
                        label: 'Yes',
                        onClick: () => sendBulkInvoiceEmail(selectedRows.map(item => item.id))
                    },
                    {
                        label: 'No',
                        onClick: () => {}
                    }
                ]
            });
        }
        return <Button className='btn btn-success' key="sendEmail" onClick={handleSendEmail}> Send Email </Button>

    }, [selectedRows, toggleCleared]);

    const handleEmailInvoice = (e, payload) => {
        confirmAlert({
            title: 'Email Invoice',
            message: `Do you want to send this invoice to ${payload.student_name} ?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => sendBulkInvoiceEmail([payload.id])
                },
                {
                    label: 'No',
                    onClick: () => {}
                }
            ]
        });
        e.preventDefault();
    }

    const handleEmailChange = (e) => {
        setHasMail(e.target.value)
        if(e.target.value == 'not_applicable'){
            searchParams.delete('hasMessageSent')
            searchParams.set('mailable', 'false')
        }else if(e.target.value == 'yes' || e.target.value == 'no'){
            searchParams.set('mailable', 'true')
            searchParams.set('hasMessageSent', e.target.value == 'yes' ? 'true' : 'false')
        }else{
            searchParams.delete('mailable')
            searchParams.delete('hasMessageSent')
        }
        setSearchParams(searchParams)
    }
    
    return (
        <div>
            <div>
                {/* Content Header (Page header) */}
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Manage Student Invoices</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">Manage Student Invoices</li>
                                </ol>
                            </div>
                        </div>
                    </div>{/* /.container-fluid */}
                </section>
                {/* Main content */}
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div style={{ marginBottom: 10 }} className="row">
                                    
                                </div>
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Manage Student Invoices</h3>
                                    </div>
                                    <div className="card-body">
                                        <div className='col-md-12'>
                                            {/* <div className="external-event" style={{backgroundColor: "rgb(248 213 76)", position: 'relative', zIndex: 'auto', left: '0px', top: '0px', width: '13%', fontWeight: 400, cursor:'default'}}>Generate Invoice</div> */}
                                            <div className="card">
                                                <div className="card-body" style={{backgroundColor: 'rgb(248 241 208)'}}>
                                                    <form onSubmit={handleSubmit}>
                                                        <div className='row'>
                                                            <div className="col-sm-3">
                                                                <Select
                                                                    ref={selectRefGen}
                                                                    name="franchiseId"
                                                                    placeholder="Search By Franchise"
                                                                    options={franchisesGen}
                                                                    getOptionValue={(option)=>`${option['id']}`}
                                                                    getOptionLabel={(option)=>`${option['name']}`}
                                                                    onChange={ (option) => { 
                                                                        if(option){
                                                                            setFieldValue("franchise_id", option.id)
                                                                        }else{
                                                                            setFieldValue("franchise_id", '')
                                                                        }
                                                                    }}
                                                                    styles={customStylesSelect}
                                                                />
                                                                {(touched.franchise_id && errors.franchise_id) && (
                                                                    <div className="text-danger">
                                                                        {errors.franchise_id}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="col-sm-3">
                                                                <select
                                                                    className="form-control"
                                                                    name="year"
                                                                    onChange={ (e) => { onYearChange(e) }} 
                                                                    value={values.year}
                                                                >
                                                                    <option value="">Select Year</option>
                                                                    {years.map((year) => (
                                                                        <option key={year} value={year}>
                                                                            {year}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                {(touched.year && errors.year) && (
                                                                    <div className="text-danger">
                                                                        {errors.year}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="col-sm-3">
                                                                <select
                                                                    className="form-control"
                                                                    name="month"
                                                                    onChange={handleChange} 
                                                                    value={values.month}
                                                                >
                                                                    <option value="">Select Month</option>
                                                                    { months.map((obj) => (
                                                                        <option key={obj.name} value={obj.id}>
                                                                            {obj.name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                {(touched.month && errors.month) && (
                                                                    <div className="text-danger">
                                                                        {errors.month}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="col-sm-3">
                                                                <Button type="submit" isLoading={isInvoiceLoading} className="btn btn-primary mr-2">Generate Invoices</Button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                        <hr style={{borderTop: '2px solid rgba(0,0,0,.125)'}}/>
                                        <div className="row mb-2">
                                            <div className="col-sm-2">
                                                <input type="text" name='invoiceNumber' className="form-control" value={searchParams.get('invoiceNumber') ?? ''} onChange={(e) => {searchParams.set('invoiceNumber', e.target.value); setSearchParams(searchParams)}} placeholder="Search By Invoice Id" />
                                            </div>
                                            <div className="col-sm-2">
                                                <input type="text" name='studentName' className="form-control" value={searchParams.get('studentName') ?? ''} onChange={(e) => {searchParams.set('studentName', e.target.value); setSearchParams(searchParams)}} placeholder="Search By Student" />
                                            </div>
                                            <div className="col-sm-2">
                                                <Select
                                                    ref={selectRef}
                                                    name="franchiseId"
                                                    placeholder="Search By Franchise"
                                                    options={franchises}
                                                    getOptionValue={(option)=>`${option['id']}`}
                                                    getOptionLabel={(option)=>`${option['name']}`}
                                                    onChange={ (option) => {onChangeFranchise(option)}}
                                                    value={franchises.filter(function(option) {
                                                        return option.id == searchParams.get('franchiseId');
                                                    })}
                                                    styles={customStylesSelect}
                                                />
                                            </div>
                                            <div className="col-sm-2">
                                                <input type="text" name='invoiceAmount' className="form-control" value={searchParams.get('invoiceAmount') ?? ''} onChange={(e) => {searchParams.set('invoiceAmount', e.target.value); setSearchParams(searchParams)}} placeholder="Search By Amount" />
                                            </div>
                                            <div className="col-sm-2">
                                                <input type="text" name='invoiceAmountOutstanding' className="form-control" value={searchParams.get('invoiceAmountOutstanding') ?? ''} onChange={(e) => {searchParams.set('invoiceAmountOutstanding', e.target.value); setSearchParams(searchParams)}} placeholder="Search By Outstanding Amount" />
                                            </div>
                                            <div className="col-sm-2">
                                                <input type="text" name='invoiceAmountPaid' className="form-control" value={searchParams.get('invoiceAmountPaid') ?? ''} onChange={(e) => {searchParams.set('invoiceAmountPaid', e.target.value); setSearchParams(searchParams)}} placeholder="Search By Paid Amount" />
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-sm-2">
                                                <select
                                                    className="form-control"
                                                    name="invoiceStatus"
                                                    onChange={(e) => {  searchParams.set('invoiceStatus', e.target.value); setSearchParams(searchParams)}}
                                                    value={searchParams.get('invoiceStatus') ?? ''}
                                                >
                                                    <option value="">Search By Status</option>
                                                    {invoiceStatuses.map((obj) => (
                                                        <option key={obj.value} value={obj.value}>
                                                            {obj.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            { canAccess?.['send-invoice-email'] && (
                                                <div className="col-sm-2">
                                                    <select
                                                        className="form-control"
                                                        name="invoiceStatus"
                                                        onChange={(e) => { handleEmailChange(e) }}
                                                        value={hasMail}
                                                    >
                                                        <option value="">Search By Mail Sent</option>
                                                        <option value="yes">Yes</option>
                                                        <option value="no">No</option>
                                                        <option value="not_applicable">N/A</option>
                                                    </select>
                                                </div>
                                            )}
                                            <div className='col-sm-4'>
                                                <Button type="submit" isLoading={isLoading} onClick={handleResetFilter} className="btn btn-warning mr-2">Reset Filter</Button>
                                                { canAccess['export-invoice-csv'] &&
                                                    <Button type="submit" isLoading={isLoading} onClick={exportCSV} className="btn btn-success"><i className="fas fa-file-csv"></i> Export</Button>
                                                }
                                            </div>
                                        </div>

                                        <DataTable
                                            title="Student Invoices"
                                            columns={columns}
                                            data={students}
                                            pagination
                                            paginationServer
                                            paginationTotalRows={totalRows}
                                            paginationDefaultPage={Number(currentPage)}
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handlePerRowsChange}
                                            paginationPerPage={Number(perPage)}
                                            paginationRowsPerPageOptions={[5, 10, 20, 30, 50, 100]}
                                            progressPending={isLoading}
                                            sortServer
                                            onSort={handleSort}
                                            customStyles={customStyle}
                                            selectableRows={canAccess?.['send-invoice-email']}
                                            onSelectedRowsChange={handleSelectedRows}
                                            contextActions={contextActions} 
                                            clearSelectedRows={toggleCleared}
                                            selectableRowDisabled={rowDisabledCriteria}
                                            selectableRowsHighlight={true}
                                            // selectableRowsNoSelectAll={true}
                                        />
                                    </div>
                                    {/* /.card-body */}
                                </div>
                            </div>
                            {/* /.col */}
                        </div>
                        {/* /.row */}
                    </div>
                    {/* /.container-fluid */}
                </section>
                {/* /.content */}
            </div>
            <PayInvoiceAmountModal
                show={show}
                handleClose={handleClose}
                payload={payload}
                callBackGetAllStudentInvoices={getAllStudentInvoices}
            />
        </div>
    )
};

export default ListStudentInvoices;